import styled from 'styled-components';

export const Container = styled.div`
  background-color: #fec3c0;
  padding: 150px 0;
`;

export const Content = styled.div`
  max-width: 1120px;
  margin: 0 auto;
`;

export const ContentDepoiments = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 2em;
`;
export const ContainerText = styled.div`
  text-align: center;
  padding: 0 0 50px 0;
`;

//novocss

export const ContainerDepoiment = styled.div`
  p,
  strong {
    font-family: 'Inter', sans-serif;
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerDepoimentFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  width: 80%;
`;

export const ContainerDepoimentFooterPagination = styled.div`
  p {
    font-size: 28px;
  }

  @media (max-width: 425px) {
    font-size: 14px;
    font-weight: bold;
  }
`;

export const ContainerDepoimentFooterInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  p {
    font-size: 28px;
  }

  strong {
    font-size: 28px;
    font-weight: bold;
  }

  @media (max-width: 425px) {
    p,
    strong {
      font-size: 14px;
      text-align: right;
    }

    strong {
      font-weight: bold;
    }
  }
`;

export const ContainerDepoimentDesc = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const OpenAspas = styled.div`
  height: 100%;
  margin-bottom: auto;

  @media (max-width: 425px) {
    margin-right: auto;
    padding-left: 20px;
  }
`;
export const CloseAspas = styled.div`
  height: 100%;
  margin-top: auto;

  @media (max-width: 425px) {
    margin-left: auto;
    padding-right: 20px;
  }
`;

export const ContainerDepoimentDescTxt = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  p {
    width: 60%;
    font-size: 28px;
    line-height: 28px;
  }

  @media (max-width: 991.98px) {
    p {
      font-size: 22px;
      line-height: 23px;
    }
  }

  @media (max-width: 502px) {
    flex-direction: column;
    p {
      font-size: 16px;
      line-height: 23px;
    }
  }
`;

export const ContainerDots = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 22px;
`;
